/**
 * Drop-in shim for `react-native-webview` on the web build.
 *
 * Webpack aliases `react-native-webview` to this file. We render a plain
 * <iframe> with the same outer style box so YouTube/HTML embeds in guides
 * keep working on web. The native-only props (javaScriptEnabled, domStorageEnabled,
 * mediaPlaybackRequiresUserAction, etc.) are accepted and ignored — modern
 * browsers grant those by default.
 */
import React from 'react';
import { View } from 'react-native';

function WebView({ source, style, allowsFullscreenVideo, ...rest }) {
  const uri  = source?.uri;
  const html = source?.html;

  const iframeProps = {
    style: { border: 0, width: '100%', height: '100%', backgroundColor: '#000' },
    allow: 'autoplay; encrypted-media; picture-in-picture',
    allowFullScreen: allowsFullscreenVideo !== false,
    referrerPolicy: 'no-referrer-when-downgrade',
  };

  if (html) iframeProps.srcDoc = html;
  else if (uri) iframeProps.src = uri;

  return (
    <View style={[{ flex: 1, backgroundColor: '#000' }, style]}>
      <iframe title={rest.title || 'embedded content'} {...iframeProps} />
    </View>
  );
}

export default WebView;
export { WebView };
